import {
  Modal,
  Form,
  ModalProps,
  FormProps,
  Input,
  Row,
  Col,
  Button,
  Icons,
  Select,
  Descriptions,
  useSelect,
  DateField,
  Space,
  Tag,
  Typography,
} from '@pankod/refine-antd'
import { useCreateMany, useGetIdentity, useTable } from '@pankod/refine-core'
import dayjs from 'dayjs'
import { IPaperTemplate, IPaperTemplateSubSection, IProject, ITestTrack, IWorkRequestStatus } from 'interfaces'
import React, { useEffect, useState } from 'react'
import { INotification } from 'interfaces'
import sendEmail from 'sendmail'
import paperMetaData from 'metadata/paper'
import { useUserContext } from 'context/user'

type CreateTestEventWRProps = {
  modalProps: ModalProps
  formProps: FormProps
  record: any
  request: any
}
export const EditTestEventWorkRequest: React.FC<CreateTestEventWRProps> = ({ modalProps, formProps, record, request }) => {
  const { Text } = Typography
  const { data: user } = useGetIdentity()
  const { paperApproverList, paperSetterList } = useUserContext()
  // const paper_setter_id = Form.useWatch(['paper_setter_id'], formProps.form)
  // const paper_approver_id = Form.useWatch(['paper_setter_id'], formProps.form)
  // console.log(paper_setter_id, paper_approver_id, 'sid')
  const { mutateAsync: createNotification } = useCreateMany<INotification>()

  const [selectedPaperSetter, setSelectedPaperSetter] = useState<object[]>([])
  const [showPaperTemplateList, setShowPaperTemplateList] = useState(false)
  const [testTrackChange, setTestTrackChange] = useState(false)
  const [selectedTesttracks, setSelectedTesttracks] = useState<object[]>([])
  const [requestType, setRequestType] = useState<string>('')

  const [selectedPaperTemplates, setSelectedPaperTemplates] = useState<object[]>([])
  const [paperSetter, setPaperSetter] = useState<string>()
  const [paperApprover, setPaperApprover] = useState<string>()
  const [currentKey, setCurrentKey] = useState(-1)
  const [paperListShow, setPaperListShow] = useState<boolean>(false)
  const [slotData, setSlotData] = useState<any[]>([])
  const [parentPaperDate, setParentPaperDate] = useState<string>('') //disable based on variant paper.

  //newstates
  const [selecetedTestTrack, setSelectedTestTrack] = useState<any>()
  const [selectedPaperTemplate, setSelectedPaperTemplate] = useState<any>()

  const { setFilters: setTestTrackFilters, tableQueryResult: testTrackData } = useTable<ITestTrack>({
    resource: 'test_tracks',
    metaData: {
      fields: ['name', 'id', 'subject_ids'],
    },
    permanentFilter: [
      {
        field: 'in_use',
        operator: 'eq',
        value: true,
      },
    ],
    initialPageSize: 1000,
    queryOptions: { enabled: !!modalProps?.visible },
  })
  const { setFilters: setPaperTemplateFilters, tableQueryResult: paperTemplateData } = useTable<IPaperTemplate>({
    resource: 'paper_templates',
    metaData: {
      fields: ['name', 'id', 'test_track_id'],
    },
    permanentFilter: [{ field: 'is_completed', operator: 'eq', value: true }],
    initialPageSize: 2000,
    queryOptions: { enabled: !!modalProps?.visible },
  })

  const { selectProps: workrecordStatusSelectProps } = useSelect<IWorkRequestStatus>({
    resource: 'work_request_statuses',
    optionLabel: 'name',
    optionValue: 'id',
    fetchSize: 100,
    metaData: {
      fields: ['id', 'name'],
    },
    sort: [{ field: 'name', order: 'asc' }],
    queryOptions: { enabled: !!modalProps?.visible },
  })

  // const { selectProps: projectSelectProps } = useSelect<IProject>({
  //   resource: 'project_config',
  //   fetchSize: 1000,
  //   optionLabel: 'name',
  //   optionValue: 'id',
  //   metaData: {
  //     fields: ['id', 'name'],
  //   },
  //   sort: [{ field: 'name', order: 'asc' }],
  //   onSearch: value => [
  //     {
  //       field: 'name',
  //       operator: 'contains',
  //       value: `${value.toLowerCase()}%`,
  //     },
  //   ],
  // })

  const { tableQueryResult: paperQueryResult, setFilters: setPaperFilter } = useTable({
    resource: 'papers',
    metaData: paperMetaData,
    permanentFilter: [
      { field: 'active', operator: 'eq', value: true },
      { field: 'status', operator: 'eq', value: 'Approved' },
    ],
    queryOptions: { enabled: !!modalProps?.visible },
  })
  const listOfPapers = paperQueryResult?.data?.data

  // formProps.form.f
  const handleTestTrackChange = (value: string, key: any) => {
    formProps?.form?.setFieldsValue({ paper_template_id: null })
    setSelectedPaperTemplate('')
    setSelectedTestTrack(value)
    console.log('this', value)
    setPaperTemplateFilters([
      {
        field: 'test_track_id',
        operator: 'eq',
        value: value,
      },
      { field: 'product_id', operator: 'eq', value: formProps?.initialValues?.product_id },
    ])
    let newSlotData: any = []
    record?.test_event?.slots?.map((eachSlot: any) => {
      // if (eachSlot?.id === value) {
      //   for (let key in eachSlot?.slots) {
      //     let timeRange = eachSlot?.slots[key].map((timeSlot: any) => {
      //       return { date: key, time: timeSlot }
      //     })
      //     newSlotData.push(...timeRange)
      //   }
      // }
      if (eachSlot?.test_track_id === value) {
        newSlotData = eachSlot?.list_of_slots
      }
    })
    console.log('newSlotData', newSlotData)
    setSlotData(newSlotData)
    // let arr: object[] = [...selectedTesttracks]

    // arr.map((item: any, index: any) => {
    //   if (index === key) {
    //     item['test_track_id'] = value
    //   }
    // })
    // if (arr.length - 1 < key) {
    //   arr.push({
    //     index: key,
    //     test_track_id: value,
    //   })
    // }
    // const fields = formProps?.form?.getFieldsValue()
    // const { paper_setters_approvers } = fields
    // Object.assign(paper_setters_approvers[key], { paper_template_id: null })
    // formProps?.form?.setFieldsValue({ paper_setters_approvers })
    // // form.setFieldsValue({ projects })

    // // formProps?.form?.setFieldsValue({
    // //   'paper_setters_approvers_'+0+'_paper_template_id':null
    // // })
    // setCurrentKey(key)
    // setSelectedTesttracks(arr)
    // setTestTrackChange()
    setShowPaperTemplateList(true)
  }

  // const paperApproverChange = (value: string) => {
  //   setPaperSetter(value)
  // }

  const handlePaperTemplateChange = (value: { value: any }) => {
    setSelectedPaperTemplate(value)
    let arr: object[] = [...selectedPaperTemplates]
    if (!arr.includes(value)) {
      arr.push(value)
    }
    setSelectedPaperTemplates(arr)
    // setSubSectionFilters([
    //   {
    //     field: 'paper_template_id',
    //     operator: 'eq',
    //     value: value,
    //   },
    // ])
    // setShowSubSectionDetails(true)
  }
  const handlePaperChange = (paperId: string) => {
    const paper = listOfPapers?.filter(paper => paper?.id === paperId)[0]
    console.log('paper found', paper)
    const paperSlotData = JSON.parse(paper?.slot_data)
    setParentPaperDate(JSON.stringify(paperSlotData?.date))
  }

  // const clearSlot = (fieldKey: string | number) => {
  //   const formInst = formProps?.form?.getFieldsValue()
  //   const paper_requests = formInst.paper_requests
  //   Object.assign(paper_requests[fieldKey], { slot_data: '' })
  //   formProps?.form?.setFieldsValue({ paper_requests })
  // }

  useEffect(() => {
    setPaperFilter(
      [
        { field: 'test_event_id', operator: 'eq', value: record?.test_event_id },
        { field: 'paper_template_id', operator: 'eq', value: record?.paper_template_id },
      ],
      'replace'
    )
    setParentPaperDate(record?.parent_paper?.slot_data)
    let newSlotData: any = []
    record?.test_event?.slots?.map((eachSlot: any) => {
      // if (eachSlot?.id === record?.test_track_id) {
      //   for (let key in eachSlot?.slots) {
      //     let timeRange = eachSlot?.slots[key].map((timeSlot: any) => {
      //       return { date: key, time: timeSlot }
      //     })
      //     newSlotData.push(...timeRange)
      //   }
      // }
      if (eachSlot?.test_track_id === record?.test_track_id) {
        newSlotData = eachSlot?.list_of_slots
      }
    })
    console.log('newSlotData', newSlotData)
    setSlotData(newSlotData)
    if (record?.variant_paper_id !== undefined || record?.variant_paper_id !== null) {
      if (record?.variant_paper_id?.length > 0) setPaperListShow(true)
    }
  }, [record])

  useEffect(() => {
    formProps?.initialValues &&
      setTestTrackFilters([
        {
          field: 'id',
          operator: 'in',
          value: formProps?.initialValues?.product?.test_track_ids,
        },
      ])
  }, [formProps?.initialValues])
  useEffect(() => {
    setPaperTemplateFilters([
      {
        field: 'test_track_id',
        operator: 'eq',
        value: formProps?.initialValues?.test_track_id,
      },
      { field: 'product_id', operator: 'eq', value: formProps?.initialValues?.product_id },
    ])
    // let arr: object[] = [...selectedTesttracks]
    //  if (!arr.includes(value)) {
    //    arr.push(value)
    //  }
    // setSelectedTesttracks(record?.test_track_ids)

    setShowPaperTemplateList(true)
  }, [formProps?.initialValues])
  useEffect(() => {
    let arr: object[] = []
    let test_track_details: object[] = []
    if (JSON.stringify(record?.paper_setters_approvers) !== '{}') {
      record?.paper_setters_approvers?.map((item: any, index: any) => {
        arr.push(item?.paper_template_id)
        test_track_details.push({
          index: index,
          test_track_id: item?.test_track_id,
        })
      })
    }
    setSelectedTesttracks(test_track_details)
    setSelectedPaperTemplates(arr)
    setSelectedPaperSetter(record?.paper_setter_ids)
  }, [record])

  const onFinish = async (values: any) => {
    let mail_arr: object[] = []
    let notification_arr: object[] = []
    let paper_setter_ids: object[] = []
    let test_track_ids: object[] = []
    let paper_template_ids: object[] = []

    if (JSON.stringify(values?.paper_setters_approvers) !== '{}') {
      values?.paper_setters_approvers?.map((item: any) => {
        if (!paper_setter_ids.includes(item?.paper_setter_ids)) {
          paper_setter_ids.push(item?.paper_setter_ids)
        }
        if (!test_track_ids.includes(item?.test_track_id)) {
          test_track_ids.push(item?.test_track_id)
        }
        if (!paper_template_ids.includes(item?.paper_template_id)) {
          paper_template_ids.push(item?.paper_template_id)
        }
      })
    }
    const paperSetterDetails = paperSetterList.filter(eachSetter => eachSetter?.id === values?.paper_setter_id)[0]
    const paperApproverDetails = paperApproverList.filter(eachApprover => eachApprover?.id === values?.paper_approver_id)[0]

    if (formProps?.initialValues?.paper_setter_id !== values?.paper_setter_id) {
      mail_arr.push({
        subject: 'A paper request has been created and assigned to you.',
        to: [{ name: `${paperSetterDetails?.displayName}`, email: `${paperSetterDetails?.email}` }],
        htmlContent: `<html><body>Hi,<br/><h4> Paper Request ${values?.name} is created by ${user?.displayName} and assigned to you. You have to set a paper. For more information, Login to <a href="${process.env.REACT_APP_PRODUCTION_URL}" target='_blank'>centa ams</a> .</h4></body></html>`,
      })
      notification_arr.push({
        description: `You are assigned as paper setter for the paper request ${values?.name} `,
        sender: user?.id,
        recepient: values?.paper_setter_id,
        source_name: 'paper_requests',
        title: 'New Task',
        recepient_user_role: 'papersetter',
        redirect_component: 'show',
        redirect_id: record?.id,
      })
    }

    if (formProps?.initialValues?.paper_approver_id !== values?.paper_approver_id) {
      mail_arr.push({
        subject: 'A paper request has been created and assigned to you.',
        to: [{ name: `${paperApproverDetails?.displayName}`, email: `${paperApproverDetails?.email}` }],
        htmlContent: `<html><body>Hi,<br/><h4> Paper Request ${values?.name} is created by ${user?.displayName} and assigned to you. You have to approve a paper. For more information, Login to <a href="${process.env.REACT_APP_PRODUCTION_URL}" target='_blank'>centa ams</a> .</h4></body></html>`,
      })
      notification_arr.push({
        description: `You are assigned as paper approver for the paper request ${values?.name} `,
        sender: user?.id,
        recepient: values?.paper_approver_id,
        source_name: 'paper_requests',
        title: 'New Task',
        recepient_user_role: 'paperapprover',
        redirect_component: 'show',
        redirect_id: record?.id,
      })
    }

    await createNotification({ resource: 'notifications', values: notification_arr })
    await sendEmail(mail_arr)

    return (
      formProps.onFinish &&
      formProps.onFinish({
        ...values,
        name: values?.name,
        description: values?.description,
        updated_by: user?.id,
        project_id: values?.project_id || null,
        // parent_paper_id: values?.request_type === 'variant' ? values?.parent_paper_id : undefined,
        // status: values?.status,
        // test_event_id: values?.test_event_id,
        // paper_setter_ids: paper_setter_ids,
        // paper_setters_approvers: values?.paper_setters_approvers,
        // test_track_ids: test_track_ids,
        // paper_template_ids: paper_template_ids,
      })
    )
  }

  return (
    <Modal
      {...modalProps}
      title="Edit Test Event Paper Request"
      afterClose={() => {
        formProps?.form?.resetFields()
      }}
    >
      {JSON.stringify(formProps?.initialValues) !== '{}' ? (
        <Descriptions size="small" column={3}>
          {formProps?.initialValues?.test_event && (
            <Descriptions.Item label="Test Event Name">{formProps?.initialValues?.test_event?.name}</Descriptions.Item>
          )}
          {formProps?.initialValues?.product && <Descriptions.Item label="Product Name">{formProps?.initialValues?.product.name}</Descriptions.Item>}
        </Descriptions>
      ) : null}
      <Form {...formProps} size="large" layout="vertical" onFinish={onFinish}>
        <Row gutter={[16, 0]}>
          <Col xs={24} lg={8}>
            <Form.Item
              label="Work Request Name"
              name="name"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} lg={16}>
            <Form.Item label="Description" name="description">
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item label="Status" name="status" initialValue={'Open'} rules={[{ required: true }]}>
              <Select {...workrecordStatusSelectProps} />
            </Form.Item>
          </Col>
          {/* <Col xs={24} lg={8}>
            <Form.Item label="Project" name="project_id" rules={[{ required: true, message: 'Please select an project...' }]}>
              <Select {...projectSelectProps} allowClear />
            </Form.Item>
          </Col> */}
          {/* <Col xs={24} lg={8}>
            <Form.Item
              label="Test Track"
              name="test_track_id"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select onChange={handleTestTrackChange}>
                {JSON.stringify(testTrackData?.data?.data) !== '{}' &&
                  testTrackData?.data?.data.map((item: any) => (
                    <option key={item?.id} value={item?.id}>
                      {item?.name}
                    </option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item
              label="Paper Template"
              name="paper_template_id"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select onChange={handlePaperTemplateChange}>
                {showPaperTemplateList &&
                  JSON.stringify(paperTemplateData?.data?.data) !== '{}' &&
                  paperTemplateData?.data?.data?.map((item: any) => (
                    <option key={item?.id} value={item?.id}>
                      {item?.name}
                    </option>
                  ))}
              </Select>
            </Form.Item>
          </Col> */}
        </Row>
        {/* <Row gutter={[16, 0]}>
          <Col lg={24}>
            <Form.List name="paper_setters_approvers">
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }) => (
                    <Row gutter={[16, 0]}>
                      <Col xs={24} lg={5}>
                        <Form.Item
                          label="Test Track"
                          {...restField}
                          name={[name, 'test_track_id']}
                          rules={[{ required: true, message: 'Missing first name' }]}
                        >
                          <Select onChange={handleTestTrackChange}>
                            {JSON.stringify(testTrackData?.data?.data) !== '{}' &&
                              testTrackData?.data?.data.map((item: any) => (
                                <option key={item?.id} value={item?.id}>
                                  {item?.name}
                                </option>
                              ))}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col xs={24} lg={5}>
                        <Form.Item
                          label="Paper Template"
                          {...restField}
                          name={[name, 'paper_template_id']}
                          rules={[{ required: true, message: 'Missing first name' }]}
                        >
                          <Select onChange={handlePaperTemplateChange}>
                            {showPaperTemplateList &&
                              JSON.stringify(paperTemplateData?.data?.data) !== '{}' &&
                              paperTemplateData?.data?.data?.map((item: any) => (
                                <option key={item?.id} value={item?.id}>
                                  {item?.name}
                                </option>
                              ))}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col lg={5}>
                        <Form.Item
                          label="Paper Setter"
                          {...restField}
                          name={[name, 'paper_setter_ids']}
                          rules={[
                            {
                              required: true,
                            },
                          ]}
                        >
                          <Select onChange={(value: any) => changePaperSetter(value)}>
                            {paperSetterList.length > 0 &&
                              paperSetterList?.map(
                                item => (
                                  // !selectedPaperSetter.includes(item?.id) ? (
                                  <option key={item?.id} value={item?.id}>
                                    {item?.displayName}
                                  </option>
                                )
                                // ) : null
                              )}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col lg={5}>
                        <Form.Item
                          label="Paper Approver"
                          {...restField}
                          name={[name, 'paper_approver_ids']}
                          rules={[
                            {
                              required: true,
                            },
                          ]}
                        >
                          <Select mode="multiple">
                            {paperApproverList.length > 0 &&
                              paperApproverList?.map(item => (
                                <option key={item?.id} value={item?.id}>
                                  {item?.displayName}
                                </option>
                              ))}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col lg={4}>
                        {' '}
                        <Icons.MinusCircleOutlined onClick={() => remove(name)} />
                      </Col>
                    </Row>
                  ))}
                  {/* <Row gutter={[16, 0]}> */}

        {/* <Form.Item>
                    <Button
                      type="dashed"
                      onClick={() => add()}
                      block
                      icon={<Icons.PlusOutlined />}
                      // disabled={paperSetterList.length === selectedPaperSetter.length}
                    >
                      Add Users
                    </Button>
                  </Form.Item>
                  {/* </Row> */}
        {/* </>
              )} */}
        {/* </Form.List> */}
        {/* <Col xs={24} lg={8}>
            <Form.Item
              label="Paper Setter"
              name="paper_setter_ids"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select mode="multiple">
                {paperSetterList.length > 0 &&
                  paperSetterList?.map(item => (
                    <option key={item?.id} value={item?.id}>
                      {item?.displayName}
                    </option>
                  ))}
              </Select>
            </Form.Item>
          </Col> */}
        {/* <Col xs={24} lg={8}>
            <Form.Item
              label="Paper Approver"
              name="paper_approver_ids"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select mode="multiple">
                {paperApproverList.length > 0 &&
                  paperApproverList?.map(item => (
                    <option key={item?.id} value={item?.id}>
                      {item?.displayName}
                    </option>
                  ))}
              </Select>
            </Form.Item>
          </Col> */}
        {/* //   </Col>
        // </Row> */}
        {/* <Row gutter={[16, 0]}> */}
        {/* {JSON.stringify(subSectionData) !== '{}' && showSubsectionDetails */}
        {/* ? subSectionData?.data?.data?.map((item: any) => ( */}
        {/* <Descriptions size="small" column={4}> */}
        {/* {item?.name && <Descriptions.Item label="Name">{item?.name}</Descriptions.Item>} */}
        {/* {item?.section?.name && <Descriptions.Item label="Section">{item?.section?.name}</Descriptions.Item>} */}
        {/* {item?.subject !== null && <Descriptions.Item label="Subject">{item?.subject?.name}</Descriptions.Item>} */}
        {/* {item?.theme !== null && <Descriptions.Item label="Theme">{item?.theme?.name}</Descriptions.Item>}
                  {item?.sub_theme !== null && <Descriptions.Item label="Sub Theme">{item?.sub_theme?.name}</Descriptions.Item>}
                  {item?.topic !== null && <Descriptions.Item label="Topic">{item?.topic?.name}</Descriptions.Item>} */}
        {/* {item?.no_of_questions && <Descriptions.Item label="Count">{item?.no_of_questions}</Descriptions.Item>} */}
        {/* {item?.mark_per_question && <Descriptions.Item label="Mark">{item?.mark_per_question}</Descriptions.Item>} */}

        {/* {item?.product?.name && <Descriptions.Item label="Product Name">{record?.product?.name}</Descriptions.Item>} */}
        {/* </Descriptions> */}
        {/* /)) */}
        {/* : null} */}
        {/* </Row> */}
        <Row gutter={[16, 0]}>
          <Col span={6}>
            <Form.Item label="Test Track" name="test_track_id" rules={[{ required: true, message: 'Missing Test Track' }]}>
              <Select onChange={handleTestTrackChange}>
                {JSON.stringify(testTrackData?.data?.data) !== '{}' &&
                  testTrackData?.data?.data.map((item: any) => (
                    <option key={item?.id} value={item?.id}>
                      {item?.name}
                    </option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item label="Paper Template" name="paper_template_id" rules={[{ required: true, message: 'Missing Paper Template' }]}>
              <Select onChange={handlePaperTemplateChange}>
                {showPaperTemplateList &&
                  JSON.stringify(paperTemplateData?.data?.data) !== '{}' &&
                  paperTemplateData?.data?.data?.map((item: any) => (
                    <option key={item?.id} value={item?.id}>
                      {item?.name}
                    </option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item label="Paper Setter" name="paper_setter_id" rules={[{ required: true, message: 'Missing Paper Setter' }]}>
              <Select
                onChange={() => {
                  console.log(formProps?.initialValues)
                }}
              >
                {paperSetterList.length > 0 && paperSetterList.map(eachSetter => <option value={eachSetter?.id}>{eachSetter?.displayName}</option>)}
              </Select>
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item label="Paper Approver" name="paper_approver_id" rules={[{ required: true, message: 'Missing Paper Approver' }]}>
              <Select>
                {paperApproverList.length > 0 &&
                  paperApproverList.map(eachApprover => <option value={eachApprover?.id}>{eachApprover?.displayName}</option>)}
              </Select>
            </Form.Item>
          </Col>
          <Col lg={7}>
            <Form.Item label="Available Slot" name="slot_data" rules={[{ required: true }]}>
              <Select>
                {slotData?.map((data, idx) => {
                  console.log('first', parentPaperDate)
                  const disabled = dayjs(data?.date) < dayjs() || JSON.stringify(data?.date) === parentPaperDate
                  return (
                    <option key={idx} value={JSON.stringify(data)} disabled={disabled}>
                      <Space>
                        <DateField value={data?.date} format="LL" disabled={disabled} />
                        <Tag>
                          {/* <Space>
                            <DateField value={data?.time?.[0]} format="LT" disabled={disabled} />
                            <Text disabled={disabled}>To</Text>
                            <DateField value={data?.time?.[1]} format="LT" disabled={disabled} />
                          </Space> */}
                          <Space>
                            <DateField value={data?.start_time} format="LT" disabled={disabled} />
                            <Text disabled={disabled}>To</Text>
                            <DateField value={data?.end_time} format="LT" disabled={disabled} />
                          </Space>
                        </Tag>
                      </Space>
                    </option>
                  )
                })}
              </Select>
            </Form.Item>
          </Col>

          {/* <Col lg={1} style={{ display: 'flex' }}>
            <Icons.MinusCircleOutlined style={{ marginTop: 'auto', paddingBottom: '16px' }} onClick={() => remove(name)} />
          </Col> */}
          <Col lg={8}>
            {' '}
            <Form.Item label="Request Type" name="request_type" rules={[{ required: true }]} initialValue="normal">
              <Select
                options={[
                  { label: 'Variant', value: 'variant' },
                  { label: 'Normal', value: 'normal' },
                ]}
                defaultValue={'normal'}
                onChange={value => {
                  if (value === 'variant') {
                    setPaperListShow(true)
                  } else if (value === 'normal') {
                    setPaperListShow(false)
                    setParentPaperDate('')
                  }
                  setRequestType(value)
                  formProps?.form?.setFieldsValue({ slot_data: '', parent_paper_id: '' })
                }}
              ></Select>
            </Form.Item>
          </Col>
          <Col lg={8}>
            <Form.Item
              label="Select one from below for prefilled Paper"
              name="parent_paper_id"
              rules={[{ required: requestType === 'variant' ? true : false }]}
            >
              <Select
                allowClear
                onChange={value => {
                  handlePaperChange(value)
                }}
                // disabled={!paperListShow || requestType === 'normal'}
                onSelect={() => formProps?.form?.setFieldsValue({ slot_data: '' })}
              >
                {listOfPapers?.map(paper => (
                  <option key={paper?.id} value={paper?.id} label={`#${record?.paper_id}`}>
                    #{paper?.paper_id}
                    {paper?.paper_smart_id}
                  </option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>

        {/* The button for below code section is kept disabled*/}
        {/* <Row gutter={[16, 0]}>
          <Col lg={24}>
            <Form.List name="paper_setters_approvers">
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }) => (
                    <Row gutter={[16, 0]}>
                      <Col xs={24} lg={5}>
                        <Form.Item
                          label="Test Track"
                          {...restField}
                          name={[name, 'test_track_id']}
                          rules={[{ required: true, message: 'Missing first name' }]}
                        >
                          <Select onChange={value => handleTestTrackChange(value, key)}>
                            {JSON.stringify(testTrackData?.data?.data) !== '{}' &&
                              testTrackData?.data?.data.map((item: any) => (
                                <option key={item?.id} value={item?.id}>
                                  {item?.name}
                                </option>
                              ))}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col xs={24} lg={5}>
                        <Form.Item
                          label="Paper Template"
                          {...restField}
                          name={[name, 'paper_template_id']}
                          rules={[{ required: true, message: 'Missing first name' }]}
                        >
                          <Select onChange={handlePaperTemplateChange}>
                            {showPaperTemplateList &&
                              JSON.stringify(paperTemplateData?.data?.data) !== '{}' &&
                              paperTemplateData?.data?.data?.map((item: any) =>
                                selectedTesttracks.length > 0 ? (
                                  selectedTesttracks.map((elem: any, index: any) =>
                                    index === key && elem.test_track_id === item?.test_track_id ? (
                                      <>
                                        <option key={item?.id} value={item?.id}>
                                          {item?.name}
                                        </option>
                                      </>
                                    ) : null
                                  )
                                ) : (
                                  <option key={item?.id} value={item?.id}>
                                    {item?.name}
                                  </option>
                                )
                              )}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col lg={5}>
                        <Form.Item
                          label="Paper Setter"
                          {...restField}
                          name={[name, 'paper_setter_ids']}
                          rules={[
                            {
                              required: true,
                            },
                          ]}
                        >
                          <Select onChange={(value: any) => changePaperSetter(value)}>
                            {paperSetterList.length > 0 &&
                              paperSetterList?.map(item => (
                                <option key={item?.user?.id} value={item?.user?.id}>
                                  {item?.user?.displayName}
                                </option>
                              ))}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col lg={5}>
                        <Form.Item
                          label="Paper Approver"
                          {...restField}
                          name={[name, 'paper_approver_ids']}
                          rules={[
                            {
                              required: true,
                            },
                          ]}
                        >
                          <Select mode="multiple">
                            {paperApproverList.length > 0 &&
                              paperApproverList?.map(item => (
                                <option key={item?.user?.id} value={item?.user?.id}>
                                  {item?.user?.displayName}
                                </option>
                              ))}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col lg={4}>
                        {' '}
                        <Icons.MinusCircleOutlined onClick={() => remove(name)} />
                      </Col>
                    </Row>
                  ))}
                  <Row gutter={[16, 0]}>
                    <Form.Item>
                      <Button
                        hidden={true}
                        type="dashed"
                        onClick={() => add()}
                        block
                        icon={<Icons.PlusOutlined />}
                        // disabled={paperSetterList.length === selectedPaperSetter.length}
                      >
                        Add Users
                      </Button>
                    </Form.Item>
                  </Row>
                </>
              )}
            </Form.List>
          </Col>
        </Row> */}
        {/* <Form.Item name="created_by" initialValue={user?.id}>
          <Input type="hidden" />
        </Form.Item>
        <Form.Item name="test_event_id" initialValue={request?.id}>
          <Input type="hidden" />
        </Form.Item> */}
        {/* <Form.Item name="paper_setter_ids" initialValue={selectedPaperSetter}>
          <Input type="hidden" />
        </Form.Item> */}
      </Form>
    </Modal>
  )
}
